import React from "react";
import { useDispatch, useSelector } from "react-redux";
import ScreenHeader from "components/items/screen-header";
import DefaultButton from "components/items/default-button";
import AccountEdit from "mdi-react/AccountEditIcon";
import { setExternalLinkTemplateFormDisabled } from "../actions/external-link-template.actions";
import { isFormDisabled } from "../reducers/external-link-template.reducers";

const ExternalLinkTemplatePageHeader = () => {
  const dispatch = useDispatch();
  const disabled = useSelector(isFormDisabled);

  return (
    <ScreenHeader
      title="External Links"
      renderActions={(
        <DefaultButton
          label="Edit"
          variant="outlined"
          color="inherit"
          disabled={!disabled}
          icon={<AccountEdit />}
          onClick={() => dispatch(setExternalLinkTemplateFormDisabled(false))}
        />
      )}
    />
  );
};

export default ExternalLinkTemplatePageHeader;
